<template>
  <div class="formTop page-chart">
    <div class="topNav">
      <ShowNavHead />
      <div class="dateSelect">
        <div class="eventSelectNav">
          <div class="eventType" v-for="(event,index) in list" :key="index" v-bind:class="{selected:isActive==index}" @click="checkItem(event,index)" v-show="hashTxt.indexOf('employee-repeatT')==-1&&hashTxt.indexOf('sameRepeatList')==-1">{{event.name}}</div>
          <div class="eventType" v-for="(event,index) in lists" :key="event.name" v-bind:class="{selected:isActive==index}" v-bind:style="{ width: index==2?110 + 'px':68+ 'px'}" @click="checkItem(event,index)" v-show="hashTxt.indexOf('employee-repeatT')>-1||hashTxt.indexOf('sameRepeatList')>-1">{{event.name}}</div>
        </div>
      </div>
      <div class="textBox">
        <!-- <transition name="slide">
         <p class="text" :key="text.id">{{text.val}}</p>
        </transition> -->
      </div>
      <div class="remindListTopRight" style="margin-right:15px">
        <!-- <el-button type="text" @click="dropDownScreen">
          <img src="../../assets/employee/images/screen.png" />
        </el-button> -->
        <div class="topInput">
          <el-input v-model.trim="strempname" placeholder="请输入项目名称、姓名或身份证号码" clearable @change="setInputVal" @keyup.enter.native="searchEnterFun" style="width:auto"></el-input>
          <el-button type="success" plain size="small" @click="searchEnterFun" style="margin-left:10px">搜索</el-button>
          <el-button type="primary" plain size="small" @click="exportFun" :loading="exportStatus" style="margin-left:10px" v-if="isRepeatPage&&isActive!='1'">导出</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      strempname: "",
      isActive: 0,
      event: "",
      eventType: "",
      //下拉筛选
      showDropScreen: -1,
      isHandled: 0,
      number: 0,
      hashTxt: '',
      //是否是重复入职页面  不是true，是 false
      isRepeatPage: false
    };
  },
  props: {
    'exportStatus': Boolean,
    list: {
      type: Array,
      default: function () {
        return [{
          name: "未处理",
          value: "0"
        },
        {
          name: "已处理",
          value: "1"
        }
        ]
      }
    },
    lists: {
      type: Array,
      default: function () {
        return [{
          name: "未处理",
          value: "0"
        },
        {
          name: "已处理",
          value: "1"
        },
        {
          name: "同公司多次入职",
          value: "2"
        }
        ]
      }
    }
  },
  computed: {
    // text () {
    //   return {
    //     id: this.number,
    //     val: this.textArr[this.number]
    //   }
    // }
  },
  created() {
    this.hashTxt = location.hash
    if (this.$route.query.pname == 'same') {
      this.isActive = '2';
      this.eventType = '2';
      this.$emit('event3', '2')
    }
    if (this.$route.query.pname == 'processed') {
      this.isActive = '1';
      this.eventType = '1';
      this.$emit('event3', '1')
    }
    if (this.$route.query.pname == 'untreated' || this.$route.query.pname == undefined) {
      this.isActive = '0';
      this.eventType = '0';
      this.$emit('event3', '0')
    }
    if (this.hashTxt.indexOf('sameRepeatList') > -1 || this.hashTxt.indexOf('employee-repeatT') > -1) {
      this.isRepeatPage = false;
      if(this.hashTxt.indexOf('sameRepeatList') > -1){
        this.isActive = '2';
        this.eventType = '2';
      }
    } else {
      this.isRepeatPage = true;
    }
  },
  mounted() {
    this.startMove()
  },
  methods: {
    setInputVal() {
      this.$emit('transformVal', this.strempname)
    },
    //事件是否处理选择
    checkItem(event, index) {
      this.isActive = index;
      this.eventType = event.value;
      this.$emit('event3', index)
      if (event.name == '同公司多次入职') {
        // this.hashTxt = '#/sameRepeatList?pname=same'
        this.$router.push({
          path: '/sameRepeatList',
          query: {
            pname: 'same'
          }
        })
        // this.searchEnterFun();
      } else if (event.name == '已处理') {
        if (this.hashTxt.indexOf('sameRepeatList') > -1) {
          this.$router.push({
            path: '/employee-repeatT',
            query: {
              pname: 'processed'
            }
          })
        } else {
          this.$router.push({
            query: {
              pname: 'processed'
            }
          })
          this.searchEnterFun();
        }
      } else if (event.name == '未处理') {
        if (this.hashTxt.indexOf('sameRepeatList') > -1) {
          this.$router.push({
            path: '/employee-repeatT',
            query: {
              pname: 'untreated'
            }
          })
        } else {
          this.$router.push({
            query: {
              pname: 'untreated'
            }
          })
          this.searchEnterFun();
        }
      }
    },
    //导出
    async exportFun() {
      this.$emit('exportMethod')
    },
    //搜索
    searchEnterFun() {
      this.$emit('fatherMethod');
    },
    //筛选下拉
    // dropDownScreen(){
    //  if( this.showDropScreen == -1){
    //     this.showDropScreen = 1
    //  }else if( this.showDropScreen == 1){
    //     this.showDropScreen = -1
    //  }
    // },
    startMove() {
      // eslint-disable-next-line
      let timer = setTimeout(() => {
        if (this.number === 2) {
          this.number = 0;
        } else {
          this.number += 1;
        }
        this.startMove();
      }, 2000); // 滚动不需要停顿则将2000改成动画持续时间
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.textBox {
  width: 220px;
  height: 40px;
  line-height: 40px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  text-align: center;
}
.text {
  width: 500px;
  position: absolute;
  bottom: 0;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s linear;
}
.slide-enter {
  transform: translateY(20px) scale(1);
  opacity: 1;
}
.slide-leave-to {
  transform: translateY(-20px) scale(0.8);
  opacity: 0;
}
</style>

<style>
.page-chart .topInput .el-input__inner {
  width: 300px;
}
.topInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
}
.topInput .el-input__icon {
  /* margin-top: 10px; */
  height: 32px;
  line-height: 32px;
}
/* .screenAndExport .el-button {
  padding: 0;
  margin-right: 20px;
}
.dialog .el-dialog__header {
  padding: 0;
}
.dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
} */
</style>
